import classNames from 'classnames';
import * as df from 'date-fns';
import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import BooksOutlineButton, {
  Sizing,
} from '../common/buttons/BooksOutlineButton';

import css from './BooksSelectedDateTimeWithChange.module.scss';

interface OwnProps {
  className?: string;
  changeTarget: () => void;
}

interface Renderable {
  date: string;
  startTime: string;
  endTime: string;
}

type Props = OwnProps & Renderable & InjectedIntlProps;

const BooksSelectedDateTimeWithChange = ({
  className,
  intl,
  date,
  startTime,
  endTime,
  changeTarget,
}: Props) => {
  const classes = classNames(css.BooksSelectedDateTimeWithChange, className);

  return (
    <div className={classes}>
      <div className={css.BooksSelectedDateTimeWithChange__Item}>
        <span>
          {intl.formatDate(df.format(date), {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            weekday: 'short',
          })}
          <span className={css.BooksSelectedDateTimeWithChange__Time}>
            {startTime}
            <span> - </span>
            {endTime}
          </span>
        </span>
        <BooksOutlineButton
          className={css.BooksSelectedDateTimeWithChange__Button}
          sizing={Sizing.Small}
          children={intl.formatMessage({ id: 'books.button.changeDateTime' })}
          onClick={changeTarget}
        />
      </div>
    </div>
  );
};

export default injectIntl(BooksSelectedDateTimeWithChange);
